import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  usePaymentTermsTemplateQuery,
  useUpdatePaymentTermsTemplate,
} from "../api/queries";
import { PaymentTermsTemplateForm } from "../ui/PaymentTermsTemplateForm";

export function PaymentTermsTemplateEditPage() {
  const { id } = useParams({
    from: "/app/performance/payment-terms-templates/$id/edit",
  });
  const nav = useNavigate({
    from: "/app/performance/payment-terms-templates/$id/edit",
  });
  const templateQuery = usePaymentTermsTemplateQuery(id);
  const updateTemplate = useUpdatePaymentTermsTemplate(id);

  const template = templateQuery.data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບເງື່ອນໄຂ",
              to: "/app/performance/payment-terms-templates",
            },
            { label: template?.name ?? "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂແມ່ແບບ</h2>
          <p className="text-muted-foreground">ປັບເນື້ອຫາເງື່ອນໄຂການຊຳລະເງິນ</p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          {templateQuery.isLoading ? (
            <p className="py-8 text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</p>
          ) : !template ? (
            <p className="py-8 text-muted-foreground text-sm">ບໍ່ພົບແມ່ແບບ</p>
          ) : (
            <PaymentTermsTemplateForm
              initialValues={{
                name: template.name,
                documentType: template.documentType,
                taxVariant: template.taxVariant,
                content: template.content,
                contentEn: template.contentEn ?? "",
                status: template.status,
                sortOrder: template.sortOrder,
                isDefault: template.isDefault,
              }}
              onSubmit={async (vals) => {
                try {
                  await updateTemplate.mutateAsync(vals);
                } catch {}
              }}
              onCancel={() =>
                nav({ to: "/app/performance/payment-terms-templates" })
              }
              submitting={updateTemplate.isPending}
            />
          )}
        </div>
      </Main>
    </>
  );
}
